import React from 'react';
import classNames from "classnames";


import './Pointer.css';


export type PointerDirection = 'top' | 'right' | 'bottom' | 'left';

export interface PointerPosition {
    top: number;
    left: number;
    direction: PointerDirection;
}

export interface PointerProps extends  PointerPosition {
    isDark: boolean;
    isRaised?: boolean;
    isLarge?: boolean;
}

export const Pointer = (
    {
        top,
        left,
        direction,
        isDark,
        isRaised,
        isLarge = false,
    }: PointerProps) => {
    return (
        <div
            className={classNames({
                'pointer': true,
                'theme-dark': isDark,
                'pointer--large': isLarge,
                'pointer--raised': isRaised,
            })}
            data-direction={direction}
            style={{top: top, left: left}}
        ></div>
    )
}